export default "__VITE_ASSET__Cba6lcbs__"